export enum NavDirection {
  PREVIOUS = 'previous',
  NEXT = 'next',
}
